import React from "react";
import { FaChevronRight } from "react-icons/fa";

function PageHeader({
  title,
  subtitle,
  breadcrumb = [],
}) {
  return (
    <div className="mb-8">

      {/* Breadcrumb */}
      {breadcrumb.length > 0 && (
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">

          <span>Admin</span>

          {breadcrumb.map((item, index) => (
            <React.Fragment key={index}>

              <FaChevronRight className="text-xs" />

              <span
                className={
                  index === breadcrumb.length - 1
                    ? "font-semibold text-teal-700"
                    : ""
                }
              >
                {item.label}
              </span>

            </React.Fragment>
          ))}

        </div>
      )}

      {/* Title */}
      <div className="flex items-center justify-between">

        <div>

          <h1 className="text-4xl font-bold text-gray-800">
            {title}
          </h1>

          {subtitle && (
            <p className="text-gray-500 mt-2 text-lg">
              {subtitle}
            </p>
          )}

        </div>

      </div>

    </div>
  );
}

export default PageHeader;